// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"styles_gridRow__puGSG","title":"styles_title__YwLgF","valueWrapper":"styles_valueWrapper__uXPcr","rawData":"styles_rawData__QU0Z0"};